import { apiRequest } from "./api";

export interface AppNotification {
  notifId: string;
  userId: string;
  type: string;
  title: string;
  body: string;
  link: string;
  read: boolean;
  entityId?: string;
  entityType?: string;
  businessId?: string;
  createdAt: string;
  updatedAt: string;
  // DDB composite keys (SK carries the createdAt for time-ordering)
  SK: string;
}

export interface NotificationsResponse {
  items: AppNotification[];
  unreadCount: number;
  nextKey: string | null;
}

export async function listNotifications(limit = 50, lastKey?: string, businessId?: string): Promise<NotificationsResponse> {
  const params = new URLSearchParams({ limit: String(limit) });
  if (lastKey) params.set("lastKey", lastKey);
  if (businessId) params.set("businessId", businessId);
  return apiRequest<NotificationsResponse>(`/me/notifications?${params}`);
}

// URL-safe base64 (no +, /, = — safe to put directly in a URL path segment)
function toBase64Url(str: string): string {
  return btoa(str).replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}

export async function markRead(notifSk: string): Promise<void> {
  const encoded = toBase64Url(notifSk);
  await apiRequest<{ success: boolean }>(
    `/me/notifications/${encoded}/read`,
    { method: "PATCH" },
  );
}

export async function markAllRead(): Promise<void> {
  await apiRequest<{ success: boolean }>("/me/notifications/read-all", { method: "PUT" });
}

export async function getVapidPublicKey(): Promise<string> {
  const res = await apiRequest<{ vapidPublicKey: string }>("/notifications/vapid-public-key");
  return res.vapidPublicKey;
}

export async function subscribePush(subscription: {
  endpoint: string;
  keys: { auth: string; p256dh: string };
}): Promise<void> {
  await apiRequest("/me/push/subscribe", {
    method: "POST",
    body: subscription,
  });
}

export async function unsubscribePush(endpoint: string): Promise<void> {
  await apiRequest("/me/push/subscribe", {
    method: "DELETE",
    body: { endpoint },
  });
}
